import {Languages} from "../../data/Languages.config";
import {i18n, useTranslation, Trans} from "next-i18next";


export default function TopHeader(props: {
    color?: string;
}) {
    const {t} = useTranslation();

    return (
        <div className={`flex justify-center bg-[#b8aa95] p-[8px] lg:p-[10px]`}>
            <p className={`text-[10px] lg:text-[12px] tracking-[1px] lg:tracking-[6px] xl:tracking-[8px] text-center uppercase text-white font-semibold`}>
                <Trans 
                    i18nKey="common.topHeaderText"
                    components={{strong: <strong />}}
                />
            </p>
        </div>
    );
}